const API_TOKEN = 'd691475908e09e'
const ISO_COUNTRY_CODE = 'CA'

const getLocationData = async () => {
  const url = `https://ipinfo.io/?token=${API_TOKEN}`

  try {
    const response = await fetch(url)
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }
    const data = await response.json()
    return data
  } catch (error) {
    console.error('Error fetching IP info:', error)
    return null
  }
}

const init = async () => {
  const data = await getLocationData()
  if (!data) return

  const { country } = data
  if (country !== ISO_COUNTRY_CODE) return
  window.promotions.splice(4, 1)

  const refs = {
    tiles: document.querySelectorAll('.free-gift'),
    subscriptionListItems: document.querySelectorAll('.selling-plan-options .purchase-details.content__subscription ul > li:nth-child(2)'),
    onetimeListItems: document.querySelectorAll('.selling-plan-options .purchase-details.content__one-time ul > li:nth-child(3)'),
  }

  Array.from([
    ...refs.tiles,
    // ...refs.subscriptionListItems,
    ...refs.onetimeListItems
  ]).forEach((el) => {
    el.style.display = 'none'
  })
}

init()
